import { AlternativesViewReadModel, AttributeReadModel } from "@Evaluation/Estimations/Domain/readmodels";

export class PanelAlternativesManagerViewModel
{
    opened: boolean = false;
    alternativesLabel: string = '';
    attributes: AttributeReadModel[] = [];
    views: AlternativesViewReadModel[] = [];
    get emailAttributes(): AttributeReadModel[] { return this.attributes.filter(a => a.Type === "Email"); }

    surveyId: number | null = null;
    descriptionTemplate: string = '';
    viewDefId: string | null = null;
    attributeId: number | null = null;

    show(surveyId: number, descriptionTemplate: string, attributeId: number | null = null, viewDefId: string | null, alternativesLabel: string, attributes: AttributeReadModel[], views: AlternativesViewReadModel[])
    {
        this.surveyId = surveyId;
        this.descriptionTemplate = descriptionTemplate;
        this.viewDefId = viewDefId;
        this.attributeId = attributeId;

        this.alternativesLabel = alternativesLabel;
        this.attributes = [...attributes];
        this.views = [... views];

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.surveyId = null;
        this.descriptionTemplate = '';
        this.viewDefId = null;
        this.attributeId = null;

        this.alternativesLabel = '';
        this.attributes = [];
        this.views = [];
    }
}

export class PanelAlternativesManagerSaveEventPayload
{
    surveyId: number;
    descriptionTemplate: string;
    viewDefId: string | null;
    attributeId: number | null;
    constructor(surveyId: number, descriptionTemplate: string, viewDefId: string | null, attributeId: number | null)
    {
        this.surveyId = surveyId;
        this.descriptionTemplate = descriptionTemplate;
        this.viewDefId = viewDefId;
        this.attributeId = attributeId;
    }
}